import script from "./Promotion.vue?vue&type=script&setup=true&lang=ts"
export * from "./Promotion.vue?vue&type=script&setup=true&lang=ts"

import "./Promotion.vue?vue&type=style&index=0&id=039d4794&lang=scss"

const __exports__ = script;

export default __exports__